<button
  type="button"
  class="cert-action-btn"
  [class.cert-action-btn-danger]="variant === 'danger'"
  [disabled]="disabled"
  (click)="onPressed()"
>
  <i *ngIf="iconClass" class="fa" [ngClass]="iconClass" aria-hidden="true"></i>
  <span>{{ label }}</span>
</button>
